import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Shearchbar.css";
const Navbar = () => {
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsHeaderFixed(true);
      } else {
        setIsHeaderFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isHeaderFixed]);

  return (
    <div>
      <header
        style={{ backgroundColor: "#1e40af", padding: "0px", color: "#fff", zIndex: "4" }}
        className={`.is-sticky  header ${isHeaderFixed ? "fixed" : ""}`}
        
      >
        <div class="container position-relative">
          <div class="row align-items-center">
            <div class="col-md-8">
              <ul class="main-menu" style={{ color: "#fff"}} >
                <li class="main-menu-item position-relative" >
                  <Link class="main-menu-link" to="/" >
                    Home
                  </Link>
                </li>

                <li class="main-menu-item position-relative">
                  <Link class="main-menu-link" to="/astrologer">
                    Astrologer
                  </Link>
                </li>

                <li class="main-menu-item position-relative">
                  <Link class="main-menu-link" to="/aboutUs">
                    About us
                  </Link>
                </li>
                
                <li class="main-menu-item position-relative">
                  <Link class="main-menu-link" to="/contect_us">
                    Contact us
                  </Link>
                </li>
              </ul>
            </div>
            
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
